// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2715":"b8a11a98cbb6bfb5","3942":"a327c4683d76e51e","4213":"e09d907904604b2f","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};